/**
 * Các option chuẩn hóa lại query
 */
 export default {
    Dot: {
        Remove: 0, // Xóa phần extention đi
        Seperate: 1, // Chuyển thành dấu /
    }
  };
  